import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("contentos_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("contentos_token");
    if (!token) { setLoading(false); return; }
    api.get("/api/auth/me").then(({ data }) => {
      setUser(data);
      localStorage.setItem("contentos_user", JSON.stringify(data));
    }).catch(() => {
      localStorage.removeItem("contentos_token");
      localStorage.removeItem("contentos_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    localStorage.setItem("contentos_token", data.access_token);
    localStorage.setItem("contentos_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, purchase_id) => {
    const payload = { email, password, name };
    if (purchase_id) payload.purchase_id = purchase_id;
    const { data } = await api.post("/api/auth/register", payload);
    localStorage.setItem("contentos_token", data.access_token);
    localStorage.setItem("contentos_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("contentos_token");
    localStorage.removeItem("contentos_user");
    setUser(null);
    window.location.href = "/";
  };

  const refresh = async () => {
    const { data } = await api.get("/api/auth/me");
    setUser(data);
    localStorage.setItem("contentos_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
